$(".accordion-item__title").click(function(){
    $(this).siblings(".accordion-item__panel").slideToggle("slow");
    $(this).toggleClass('active_accordion');
  });

$('.single-option-radio label').click(function(){
    $('span.prescription').text(': '+$(this).text());
    if($(this).text() == 'Single Vision Prescription'){
       $('.selector-wrapper.bcpo-simple.bcpo-grid').slideDown("slow");
       $('span.prescription').append(' (+£70.00)');
       $('table.bcpo-table select').prop("required", true);
    }else{
        $('.selector-wrapper.bcpo-simple.bcpo-grid').slideUp("slow");
        $('table.bcpo-table select').prop('selectedIndex', 0);
        $('table.bcpo-table select').prop("required", false);
    }  
})
$(document).ready(function() {
  var selectedVariantName =  $('.single-option-selector__radio:checked').val();
  if(selectedVariantName == 'Single Vision Prescription'){
       $('.selector-wrapper.bcpo-simple.bcpo-grid').show();
       $('table.bcpo-table select').prop("required", true);
    }else{
        $('.selector-wrapper.bcpo-simple.bcpo-grid').hide();
        $('table.bcpo-table select').prop('selectedIndex', 0);
        $('table.bcpo-table select').prop("required", false);
    }  
});
